import { getHandle } from 'utils/router/utils/getHandle'

export const KeywordsRoutes = [
  {
    path: 'keywords/:rule_id/flow/:mode?/:content_id?',
    handle: getHandle('keywords'),
    lazy: () => import('./keywords-builder.page'),
  },
] as const
